import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import videoPicker_template from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/videoPicker_template";
import { articlePicker_template } from "./articlePicker_template";
import { tagPicker_template } from "./tagPicker_template";
import { vignettePicker_template } from "./vignettePicker_template";
import { slugify } from "../../utils/Helpers";
import EmbedHelper, { embedTypesList } from "../../utils/EmbedHelper";

enum EmbedContext {
    CONTENT = "content",
}

declare var ko: any;

export class militaryBaseGuideEdit_template extends vnTemplate {
    public imagePicker: imagePicker_template;
    public videoPicker: videoPicker_template;
    public articlePicker: articlePicker_template;
    public tagPicker: tagPicker_template;
    public vignettePicker: vignettePicker_template;
    public embedHelper: EmbedHelper;

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <h3 class="form-title icon i-summary" data-bind="text: formTitle"></h3>
                    <button type="button" data-bind="click: onClickCancel" class="close-button icon i-close-2"></button>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Title</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: title"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Short Name</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: shortName"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Slug</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: slug, disable: isSlugReadOnly"></div>
                            </div>
                            <div class="form-group">
                                <input id="military-base-guide-active" type="checkbox" data-bind="checked: status">
                                <label for="military-base-guide-active" class="form-label icon i-check">Active</label>
                            </div>
                        </div>

                        <!-- ko if: entityType() == 'base' -->
                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Base Group</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: baseGroup"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Parent Base</label>
                                <select data-bind="options: bases, optionsText: 'title', optionsValue: 'id', value: idParentBase, optionsCaption: 'None'"></select>
                            </div>
                        </div>
                        <!-- /ko -->

                        <!-- ko if: entityType() == 'helpService' -->
                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Military Base</label>
                                <select data-bind="options: bases, optionsText: 'title', optionsValue: 'id', value: idBase, optionsCaption: 'Select a base'"></select>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Help Service Category</label>
                                <select data-bind="options: helpServiceCategories, optionsText: 'name', optionsValue: 'id', value: idCategory, optionsCaption: 'Select a category', disable: isHelpServiceCategoryReadOnly"></select>
                            </div>
                        </div>
                        <!-- /ko -->

                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Street 1</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressStreet1"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Street 2</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressStreet2"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Zip Code</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressZipCode"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Building Number</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressBuildingNumber"></div>
                            </div>
                        </div>

                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Cross Street</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressCrossStreet"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">City</label>
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressCity"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">State</label>
                                <!-- ko if: isUnitedStatesAddress -->
                                <select data-bind="options: stateOptions, optionsText: 'label', optionsValue: 'value', value: addressState, optionsCaption: 'Select a state'"></select>
                                <!-- /ko -->
                                <!-- ko ifnot: isUnitedStatesAddress -->
                                <div class="w-input"><input class="input-text" type="text" data-bind="value: addressState"></div>
                                <!-- /ko -->
                            </div>
                            <div class="form-group">
                                <label class="form-label">Country</label>
                                <select data-bind="options: countryOptions, optionsText: 'label', optionsValue: 'value', value: addressCountry, optionsCaption: 'Select a country'"></select>
                            </div>
                        </div>

                        <div class="form-group-row">
                            <!-- ko if: entityType() == 'base' -->
                            <div class="form-group">
                                <label class="form-label">Base Image</label>
                                <button type="button" class="btn secondary icon i-image" data-bind="click: onClickSelectBaseImage, visible: !baseImage()">Select Image</button>
                                <div class="w-img" data-bind="visible: baseImage() && baseImage().url">
                                    <img data-bind="attr: { src: baseImage() ? baseImage().url : '', alt: baseImage() && baseImage().altText ? baseImage().altText : '' }" alt="" />
                                </div>
                                <div data-bind="visible: baseImage() && !baseImage().url, text: 'Selected image ID: ' + baseImage()"></div>
                                <div class="w-btn" data-bind="visible: baseImage">
                                    <button type="button" class="btn secondary icon i-edit" data-bind="click: onClickSelectBaseImage">Change Image</button>
                                    <button type="button" class="btn icon i-delete" data-bind="click: onClickRemoveBaseImage">Remove Image</button>
                                </div>
                            </div>
                            <!-- /ko -->
                            <div class="form-group">
                                <label class="form-label">Images</label>
                                <button type="button" class="btn secondary icon i-image" data-bind="click: onClickSelectImages">Select Images</button>
                                <div data-bind="visible: images().length == 0">No images selected.</div>
                                <ul class="img-picker-list selected" data-bind="foreach: images, visible: images().length > 0">
                                    <li class="img-picker-item">
                                        <button type="button" class="btn icon i-deselect" data-bind="click: $parent.onClickRemoveImage"></button>
                                        <div class="ratio-content">
                                            <img data-bind="attr: { src: url ? url + '?w=300&h=300' : '', alt: altText || '' }" alt="" />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="w-justify">
                                <label class="form-label">Linked Contacts</label>
                                <button type="button" class="btn secondary icon i-add" data-bind="click: onClickShowContactLinker">Add Contact</button>
                            </div>
                            <div data-bind="visible: linkedContacts().length == 0">No contacts linked.</div>
                            <table class="list-results" data-bind="visible: linkedContacts().length > 0">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Base</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: linkedContacts">
                                    <tr>
                                        <td data-bind="text: title"></td>
                                        <td data-bind="text: base ? base.title : ''"></td>
                                        <td>
                                            <span data-bind="text: status ? 'Active' : 'Inactive', css: { 'status-inactive': !status }"></span>
                                        </td>
                                        <td style="display: flex;">
                                            <button class="btn icon border only-icon i-view" type="button" data-bind="click: $parent.onClickViewLinkedContact"></button>
                                            <button type="button" class="btn icon border only-icon i-delete" data-bind="click: $parent.onClickRemoveLinkedContact"></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Body</label>
                            <textarea id="military_base_guide_body" style="height: 300px" data-bind="value: body"></textarea>
                        </div>
                    </div>
                </div>

                <div class="form-footer">
                    <button type="button" data-bind="click: onClickCancel" class="btn">Cancel</button>
                    <button type="button" data-bind="click: onClickSave" class="btn highlight">Save</button>
                </div>
            </div>

            <div class="military-contact-linker-modal" style="display: none; position: fixed; inset: 0; z-index: 1000; background: rgba(0, 0, 0, 0.5); align-items: center; justify-content: center; padding: 2rem;" data-bind="style: { display: isContactLinkerVisible() ? 'flex' : 'none' }">
                <div class="w-form w-form-large" style="max-height: 90vh; overflow-y: auto; width: 90%; max-width: 1100px;">
                    <div class="form-header">
                        <h3 class="form-title icon i-summary">Link Contacts</h3>
                        <button type="button" data-bind="click: onClickHideContactLinker" class="close-button icon i-close-2"></button>
                    </div>
                    <div class="w-form-body">
                        <div class="form-body">
                            <div class="form-group-row">
                                <div class="form-group">
                                    <label class="form-label">Search Contacts</label>
                                    <div class="w-input"><input class="input-text" type="text" data-bind="value: contactSearchKeyword, valueUpdate: 'afterkeydown', event: { keyup: onContactSearchKeyUp }"></div>
                                </div>
                                <div class="form-group">
                                    <input id="military-contact-search-base-group" type="checkbox" data-bind="checked: contactSearchWithinBaseGroup, enable: contactSearchBaseGroup">
                                    <label for="military-contact-search-base-group" class="form-label icon i-check">Search within base group</label>
                                    <div data-bind="visible: contactSearchBaseGroup">
                                        <small data-bind="text: contactSearchBaseGroup"></small>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button type="button" class="btn highlight" data-bind="click: onClickSearchContacts">Search</button>
                                    <button type="button" class="btn secondary" data-bind="click: onClickCreateContact">Create New Contact</button>
                                </div>
                            </div>
                            <div data-bind="visible: isContactSearchLoading">Loading contacts...</div>
                            <table class="list-results">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Base</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: contactSearchResults">
                                    <tr>
                                        <td data-bind="text: title"></td>
                                        <td data-bind="text: base ? base.title : ''"></td>
                                        <td>
                                            <span data-bind="text: status ? 'Active' : 'Inactive', css: { 'status-inactive': !status }"></span>
                                        </td>
                                        <td><button type="button" class="btn icon border only-icon" data-bind="click: $parent.onClickToggleLinkedContact, class: $parent.isContactLinked(id) ? 'i-delete' : 'i-add'"></button></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div data-bind="visible: !isContactSearchLoading() && contactSearchResults().length == 0">No contacts found.</div>
                        </div>
                    </div>
                    <div class="form-footer">
                        <button type="button" data-bind="click: onClickHideContactLinker" class="btn highlight">Done</button>
                    </div>
                </div>
            </div>

            <div data-bind="css: { 'is-visible': isEmbedPopUpVisible }" class="w-lightbox light-theme lightbox-embed right-space">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Insert Embed</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCloseEmbedPopup }"></button>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                                <button class="btn-form options icon i-dropdown-simple is-open" type="button" data-bind="event: { click: onClickToggleEmbedTypes }">Supported Platforms</button>
                                <div class="inner-group" data-bind="foreach: embedType_options">
                                    <div>
                                        <input type="radio" data-bind="checked: $parent.embedType, event: { change: $parent.onChangeEmbedInput }, attr: { value: $data.type, id: 'military-' + $data.type }">
                                        <label class="form-label" data-bind="text: $data.name, attr: { for: 'military-' + $data.type }"></label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="militaryBaseGuideEmbedSource">Embed Creator</label>
                                <textarea style="width: 100%;height: 100px;" id="militaryBaseGuideEmbedSource" placeholder="paste supported link or full embed code here" data-bind="textInput: embedSource, event: { input: onChangeEmbedInput }, valueUpdate: ['afterkeydown','propertychange','input'], hasFocus: isEmbedFocused" class="input-text"></textarea>
                            </div>
                            <div class="error form-group">
                                <p class="form-text" data-bind="text: embedErrors().message"></p>
                                <ul data-bind="foreach: embedErrors().softMatches">
                                    <li><p class="form-text" data-bind="text: $data"></p></li>
                                </ul>
                                <p class="form-text" data-bind="visible: embedErrors().softMatches && embedErrors().softMatches.length > 0">Please choose a specific supported platform from the list.</p>
                            </div>
                            <div class="preview" data-bind="visible: embedCode">
                                <div class="form-group">
                                    <label class="form-label" for="militaryBaseGuideEmbedSource" data-bind="class: previewEmbedType">Embed Code Preview</label>
                                    <pre class="scrollable" data-bind="text: embedCode"></pre>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" id="embedGeneration">
                            <section id="calculation" hidden>
                                <h2 class="form-title embed-animation">Generating Embed...</h2>
                                <progress style="display: block; width: 100%; margin-bottom: 10px;"></progress>
                                <p>
                                    Checking width:
                                    <span id="current-viewport-width"></span>
                                    <span>x</span>
                                    <span id="current-viewport-height"></span>
                                </p>
                                <div id="iframe-wrapper" style="position:absolute;left:0;top:0;opacity:0;pointer-events:none;z-index:-1;">
                                    <iframe src="about:blank"></iframe>
                                </div>
                            </section>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCloseEmbedPopup }" class="btn">Cancel</button>
                            <button type="button" data-bind="disable: embedCode() == null || embedErrors() == null, event: { click: onClickAddEmbed }" class="btn highlight">Insert</button>
                        </div>
                    </div>
                </div>
            </div>

            ${this.imagePicker.getHtmlBuild()}
            ${this.videoPicker.getHtmlBuild()}
            ${this.articlePicker.getHtmlBuild()}
            ${this.tagPicker.getHtmlBuild()}
            ${this.vignettePicker.getHtmlBuild()}
        `;
    }

    protected initPartial(): void {
        this.imagePicker = new imagePicker_template("militaryBaseGuideImagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePicker.setNumberOfRecentImages(50);
        this.videoPicker = new videoPicker_template("militaryBaseGuideVideoPicker", this.getTemplateViewModel(), this.caller);
        this.articlePicker = new articlePicker_template("militaryBaseGuideArticlePicker", this.getTemplateViewModel(), this.caller);
        this.tagPicker = new tagPicker_template("militaryBaseGuideTagPicker", this.getTemplateViewModel(), this.caller);
        this.tagPicker.setParent(this);
        this.tagPicker.set_isHyperLinkModeEnabled(true);
        this.vignettePicker = new vignettePicker_template("militaryBaseGuideVignettePicker", this.getTemplateViewModel(), this.caller);
        this.embedHelper = new EmbedHelper(this.caller);
    }

    protected getTemplateName(): string {
        return "militaryBaseGuideEdit-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        const self = this;
        const vm: any = {
            entityType: ko.observable("base"),
            formTitle: ko.observable("Military Base Guide"),
            id: ko.observable(null),
            idBase: ko.observable(null),
            idCategory: ko.observable(null),
            idParentBase: ko.observable(null),
            title: ko.observable(""),
            shortName: ko.observable(""),
            slug: ko.observable(""),
            legacySlug: ko.observable(""),
            baseGroup: ko.observable(""),
            status: ko.observable(true),
            body: ko.observable(""),
            baseImage: ko.observable(null),
            images: ko.observableArray([]),
            addressStreet1: ko.observable(""),
            addressStreet2: ko.observable(""),
            addressZipCode: ko.observable(""),
            addressBuildingNumber: ko.observable(""),
            addressCrossStreet: ko.observable(""),
            addressCity: ko.observable(""),
            addressState: ko.observable(""),
            addressCountry: ko.observable(""),
            countryOptions: ko.observableArray([]),
            stateOptions: ko.observableArray([]),
            bases: ko.observableArray([]),
            helpServiceCategories: ko.observableArray([]),
            linkedContacts: ko.observableArray([]),
            contactSearchKeyword: ko.observable(""),
            contactSearchWithinBaseGroup: ko.observable(false),
            contactSearchResults: ko.observableArray([]),
            isContactLinkerVisible: ko.observable(false),
            isContactSearchLoading: ko.observable(false),
            isEmbedPopUpVisible: ko.observable(false),
            isEmbedFocused: ko.observable(false),
            embedSource: ko.observable(null),
            embedCode: ko.observable(null),
            embedErrors: ko.observableArray([]),
            embedType_options: ko.observableArray(embedTypesList()),
            embedType: ko.observable("all"),
            embedContext: ko.observable(EmbedContext.CONTENT),
            previewEmbedType: ko.observable(""),
            activeCkEditorInstance: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions(["military_baseguide"])),
            onClickCancel: function () {
                self.caller.cancel();
            },
            onClickSave: function () {
                const vm = self.getTemplateViewModel();
                const slug = self.normalizePath(vm.isSlugReadOnly() ? vm.inferredSlug() : vm.slug());

                if (!self.isValidSlug(slug, vm.entityType())) {
                    alert("Slug must follow /base-guide/{base-slug} for bases or /base-guide/{base-slug}/{help-service-category-slug} for help services, with no trailing or extra slashes.");
                    return;
                }

                self.caller.saveEntity();
            },
            onClickShowContactLinker: function () {
                self.caller.showContactLinker();
            },
            onClickHideContactLinker: function () {
                self.caller.hideContactLinker();
            },
            onClickSearchContacts: function () {
                self.caller.searchContacts();
            },
            onContactSearchKeyUp: function (data, event) {
                if (event && event.keyCode == 13) {
                    self.caller.searchContacts();
                }
                return true;
            },
            onClickToggleLinkedContact: function (contact) {
                self.caller.toggleLinkedContact(contact);
            },
            onClickRemoveLinkedContact: function (contact) {
                self.caller.removeLinkedContact(contact);
            },
            onClickViewLinkedContact: function (contact) {
                self.caller.openContactViewTab(contact);
            },
            onClickCreateContact: function () {
                self.caller.openContactCreateTab();
            },
            onClickSelectBaseImage: function () {
                self.showImagePicker("single-select", "baseImage");
            },
            onClickRemoveBaseImage: function () {
                vm.baseImage(null);
            },
            onClickSelectImages: function () {
                self.showImagePicker("multi-select-no-gallery", "images", vm.images());
            },
            onClickRemoveImage: function (image) {
                vm.images((vm.images() || []).filter(item => String(item.id) !== String(image.id)));
            },
            isContactLinked: function (idContact) {
                return vm.linkedContactIds().indexOf(Number(idContact)) !== -1;
            },
            onClickCloseEmbedPopup: function () {
                self.toggleEmbedPopUp(false);
                self.resetEmbedPopUp();
            },
            onClickToggleEmbedTypes: function () {
                self.onClickToggleEmbedTypes();
            },
            onClickAddEmbed: function () {
                self.onClickAddEmbed();
            },
            onChangeEmbedInput: function () {
                self.onChangeEmbedInput();
            },
        };
        vm.isNewEntity = ko.computed(() => !vm.id());
        vm.selectedHelpServiceCategory = ko.computed(() => {
            return (vm.helpServiceCategories() || []).find(category => String(category.id) == String(vm.idCategory())) || null;
        });
        vm.selectedBase = ko.computed(() => {
            return (vm.bases() || []).find(base => String(base.id) == String(vm.idBase())) || null;
        });
        vm.isSlugReadOnly = ko.computed(() => {
            return true;
        });
        vm.isHelpServiceCategoryReadOnly = ko.computed(() => {
            return vm.entityType() == "helpService";
        });
        vm.inferredSlug = ko.computed(() => {
            if (vm.entityType() != "helpService") {
                return self.buildBaseGuideSlug(vm.baseGroup());
            }

            const base = vm.selectedBase();
            const baseSlug = self.buildBaseGuideSlug(base ? base.baseGroup : "");
            return baseSlug + self.getHelpServiceCategorySlug(vm.selectedHelpServiceCategory());
        });
        vm.linkedContactIds = ko.computed(() => {
            return (vm.linkedContacts() || []).map(contact => Number(contact.id));
        });
        vm.contactSearchBaseGroup = ko.computed(() => {
            if (vm.entityType() == "helpService") {
                const base = vm.selectedBase();
                return base ? (base.baseGroup || "") : "";
            }

            return vm.baseGroup() || "";
        });
        vm.isUnitedStatesAddress = ko.computed(() => {
            return vm.addressCountry() == "United States";
        });
        vm.inferredSlug.subscribe((slug) => {
            if (vm.isSlugReadOnly()) {
                vm.slug(slug);
            }
        });
        vm.addressCountry.subscribe(() => {
            vm.addressState("");
        });

        return vm;
    }

    public showImagePicker(mode, target, selectedImages = [], keyword = null): void {
        const targetName = this.resolveImagePickerTarget(target);
        const isBodyTarget = this.isBodyImagePickerTarget(targetName);
        this.imagePicker.setMode(mode);
        this.imagePicker.setTarget(targetName);
        this.imagePicker.setIsImageOptimizable(isBodyTarget);
        this.imagePicker.setSelectedImages(selectedImages || []);
        if (!isBodyTarget) {
            this.imagePicker.setImagesInContent([]);
        }
        this.caller.getImageData(keyword);
        if (mode == "multi-select" && isBodyTarget) {
            this.caller.getImagesInContent(targetName);
        }
        this.imagePicker.show();
    }

    public prepareImagePickerContext(mode, target, selectedImages = []): void {
        const targetName = this.resolveImagePickerTarget(target);
        const isBodyTarget = this.isBodyImagePickerTarget(targetName);
        this.imagePicker.setMode(mode);
        this.imagePicker.setTarget(targetName);
        this.imagePicker.setIsImageOptimizable(isBodyTarget);
        this.imagePicker.setSelectedImages(selectedImages || []);
        if (!isBodyTarget) {
            this.imagePicker.setImagesInContent([]);
        }
    }

    public showVideoPicker(target): void {
        this.caller.showVideoPicker(target);
    }

    public showArticlePicker(target, selectedText = null): void {
        this.articlePicker.showArticlePicker(target, selectedText);
    }

    public showVignettePicker(target): void {
        this.vignettePicker.showVignettePicker(target);
    }

    public editArticleElement(articleElement, target): void {
        this.articlePicker.showArticlePickerView(articleElement, target);
    }

    public editArticleGroup(groupElement, target): void {
        this.articlePicker.setTarget(target);
        this.articlePicker.show();
        this.articlePicker.fillPage();
        this.articlePicker.setArticleGroupElement(groupElement);
    }

    public setArticleGroupArticleElements(elements): void {
        this.articlePicker.setArticleGroupArticleElements(elements);
    }

    public getArticleElementInsertedFieldsInOrder(element): any {
        return this.articlePicker.getArticleElementInsertedFieldsInOrder(element);
    }

    public editVignetteElement(vignetteElement, target): void {
        this.vignettePicker.showVignettePickerInsertForm(vignetteElement, target);
    }

    public showTagPicker(mode, target, filterKeyword = null): void {
        this.tagPicker.setMode(mode);
        this.tagPicker.setTarget(target);
        this.tagPicker.setSimpleFilterKeyword(filterKeyword);
        this.tagPicker.show();
    }

    public editTagElement(tagElement, editor): void {
        this.showTagPicker("in-content", editor);
        this.tagPicker.editTagElement(tagElement);
    }

    public editTagGroup(groupElement, editor): void {
        this.showTagPicker("in-content", editor);
        this.tagPicker.setTagGroupElement(groupElement);
    }

    public getTagElementInsertedFieldsInOrder(element): any {
        return this.tagPicker.getTagElementInsertedFieldsInOrder(element);
    }

    public setTagGroupTagElements(elements): void {
        this.tagPicker.setTagGroupTagElements(elements);
    }

    public initTagPickerCkEditors(): void {
        this.tagPicker.initializeCkEditors();
    }

    public setActiveCkEditorInstance(instance): void {
        this.getTemplateViewModel().activeCkEditorInstance(instance);
    }

    public getActiveCkEditorInstance(): any {
        return this.getTemplateViewModel().activeCkEditorInstance();
    }

    public setContentEmbedContext(): void {
        const vm = this.getTemplateViewModel();
        vm.embedType_options(embedTypesList());
        vm.embedType("all");
        vm.embedContext(EmbedContext.CONTENT);
    }

    public toggleEmbedPopUp(value): void {
        document.body.classList.toggle("is-fixed", !!value);
        this.getTemplateViewModel().isEmbedPopUpVisible(value);
    }

    public setEmbedSourceFocused(value): void {
        setTimeout(() => {
            this.getTemplateViewModel().isEmbedFocused(value);
        }, 100);
    }

    public resetEmbedPopUp(): void {
        const vm = this.getTemplateViewModel();
        vm.isEmbedFocused(false);
        vm.embedSource(null);
        vm.embedType("all");
        this.clearEmbedFormOutput();

        const embedTypeLists = document.getElementsByClassName("inner-group");
        const embedTypeButtons = document.getElementsByClassName("btn-form options");
        if (embedTypeLists[0]) {
            embedTypeLists[0].classList.remove("is-open");
        }
        if (embedTypeButtons[0]) {
            embedTypeButtons[0].classList.add("is-open");
        }
    }

    public clearEmbedFormOutput(): void {
        const vm = this.getTemplateViewModel();
        vm.embedCode(null);
        vm.embedErrors([]);
    }

    public onClickToggleEmbedTypes(): void {
        const vm = this.getTemplateViewModel();
        vm.embedType("all");

        const embedTypeLists = document.getElementsByClassName("inner-group");
        const embedTypeButtons = document.getElementsByClassName("btn-form options");
        if (embedTypeLists[0]) {
            embedTypeLists[0].classList.toggle("is-open");
            if (!embedTypeLists[0].classList.contains("is-open")) {
                this.onChangeEmbedInput();
            }
        }
        if (embedTypeButtons[0]) {
            embedTypeButtons[0].classList.toggle("is-open");
        }
    }

    public onClickAddEmbed(): void {
        const embedContext = this.getTemplateViewModel().embedContext();
        const embedCode = this.getTemplateViewModel().embedCode();

        switch (embedContext) {
            case EmbedContext.CONTENT:
            default:
                this.caller.addEmbedCodeToCkEditor(embedCode);
                break;
        }
    }

    public onChangeEmbedInput(): void {
        this.clearEmbedFormOutput();
        const source = this.getTemplateViewModel().embedSource();
        if (source && source.length >= 3) {
            const embedContext = this.getTemplateViewModel().embedContext();
            this.caller.generateEmbed(source, embedContext);
        }
    }

    public setPreviewEmbedType(previewEmbedType): void {
        this.getTemplateViewModel().previewEmbedType(previewEmbedType);
    }

    public async setEmbedData(embedData): Promise<void> {
        this.getTemplateViewModel().previewEmbedType("embed_" + embedData.name);

        let markup = embedData.html;
        if (this.getTemplateViewModel().embedContext() == EmbedContext.CONTENT) {
            markup = await this.embedHelper.processContentEmbed(embedData);
        }

        this.getTemplateViewModel().embedCode(markup);
    }

    public setEmbedErrors(embedErrors): void {
        this.getTemplateViewModel().embedErrors(embedErrors);
    }

    public setEntityType(entityType: string): void {
        const vm = this.getTemplateViewModel();
        vm.entityType(entityType);
        vm.formTitle(entityType == "helpService" ? "Military Help Service" : "Military Base");
    }

    public setLookups(bases, helpServiceCategories, countries = null, usStates = null): void {
        const vm = this.getTemplateViewModel();
        vm.bases(bases || []);
        vm.helpServiceCategories(helpServiceCategories || []);
        vm.countryOptions(this.normalizeLookupOptions(countries, false));
        vm.stateOptions(this.normalizeLookupOptions(usStates, true));
    }

    public setEntity(entity): void {
        const vm = this.getTemplateViewModel();
        const address = entity.address || {};
        vm.id(entity.id || null);
        vm.idBase(entity.idBase || null);
        vm.idCategory(entity.idCategory || entity.category || null);
        vm.idParentBase(entity.idParentBase || null);
        vm.title(entity.title || "");
        vm.shortName(entity.shortName || "");
        vm.slug(entity.slug || "");
        vm.legacySlug(entity.legacySlug || "");
        vm.baseGroup(entity.baseGroup || "");
        vm.status(entity.status !== false);
        vm.body(entity.body || "");
        vm.baseImage(entity.baseImage || entity.idBaseImage || null);
        vm.images(entity.images || []);
        vm.linkedContacts([]);
        vm.addressStreet1(address.street1 || "");
        vm.addressStreet2(address.street2 || "");
        vm.addressZipCode(address.zipCode || "");
        vm.addressBuildingNumber(address.buildingNumber || "");
        vm.addressCrossStreet(address.crossStreet || "");
        vm.addressCity(address.city || "");
        vm.addressCountry(address.country || "");
        vm.addressState(address.state || "");
        this.updateInferredSlug();
    }

    public setLinkedContacts(contacts): void {
        this.getTemplateViewModel().linkedContacts(this.sortContactsByTitle(contacts || []));
    }

    public showContactLinker(): void {
        const vm = this.getTemplateViewModel();
        vm.isContactLinkerVisible(true);
        vm.contactSearchResults([]);
    }

    public hideContactLinker(): void {
        this.getTemplateViewModel().isContactLinkerVisible(false);
    }

    public isContactLinkerVisible(): boolean {
        return !!this.getTemplateViewModel().isContactLinkerVisible();
    }

    public setContactSearchLoading(isLoading: boolean): void {
        this.getTemplateViewModel().isContactSearchLoading(isLoading);
    }

    public setContactSearchResults(contacts): void {
        this.getTemplateViewModel().contactSearchResults(this.sortContactsByTitle(contacts || []));
    }

    public toggleLinkedContact(contact): void {
        if (!contact || !contact.id) {
            return;
        }

        const vm = this.getTemplateViewModel();
        if (vm.linkedContactIds().indexOf(Number(contact.id)) !== -1) {
            this.removeLinkedContact(contact);
            return;
        }

        vm.linkedContacts(this.sortContactsByTitle((vm.linkedContacts() || []).concat([contact])));
    }

    public removeLinkedContact(contact): void {
        if (!contact || !contact.id) {
            return;
        }

        const contactId = Number(contact.id);
        const vm = this.getTemplateViewModel();
        vm.linkedContacts((vm.linkedContacts() || []).filter(item => Number(item.id) !== contactId));
    }

    public getContactSearchRequest() {
        const vm = this.getTemplateViewModel();
        return {
            pagination: {
                pageNumber: 1,
                itemPerPage: 25,
            },
            orderBy: "title",
            orderByDirection: "ASC",
            filters: {
                keyword: vm.contactSearchKeyword(),
                baseGroup: vm.contactSearchWithinBaseGroup() ? vm.contactSearchBaseGroup() : "",
            },
        };
    }

    public getIdBaseForContactCreation(): number {
        const vm = this.getTemplateViewModel();
        if (vm.entityType() == "helpService") {
            return Number(vm.idBase() || 0);
        }

        return Number(vm.id() || 0);
    }

    protected sortContactsByTitle(contacts): Array<any> {
        return (contacts || []).slice().sort((a, b) => {
            return String(a.title || "").localeCompare(String(b.title || ""), undefined, { sensitivity: "base" });
        });
    }

    protected normalizeLookupOptions(lookup, useKeysAsValues: boolean): Array<any> {
        if (!lookup) {
            return [];
        }

        const keys = Array.isArray(lookup)
            ? lookup.map((value, index) => String(index))
            : Object.keys(lookup);

        return keys.map(key => {
            const label = Array.isArray(lookup) ? lookup[Number(key)] : lookup[key];
            return {
                value: useKeysAsValues ? key : label,
                label: label,
            };
        }).filter(option => option.label !== null && option.label !== undefined && option.label !== "");
    }

    public setDefaultBase(idBase): void {
        this.getTemplateViewModel().idBase(idBase || null);
    }

    public setDefaultCategory(idCategory): void {
        this.getTemplateViewModel().idCategory(idCategory || null);
    }

    protected updateInferredSlug(): void {
        const vm = this.getTemplateViewModel();
        if (vm.isSlugReadOnly()) {
            vm.slug(vm.inferredSlug());
        }
    }

    protected buildBaseGuideSlug(baseGroup): string {
        const slug = slugify(baseGroup || "", { preserveNumbers: true });
        return slug ? "/base-guide/" + slug : "/base-guide/";
    }

    protected getHelpServiceCategorySlug(category): string {
        if (!category) {
            return "";
        }

        const categorySlug = category.slug || (category.details && category.details.slug) || slugify(category.name || "", {preserveNumbers: true});
        if (!categorySlug) {
            return "";
        }

        return "/" + String(categorySlug).replace(/^\/+|\/+$/g, "");
    }

    private isValidSlug(slug: string, entityType: string): boolean {
        if (typeof slug !== "string") {
            return false;
        }

        try {
            const parsedUrl = new URL(slug, window.location.origin);

            if (parsedUrl.pathname !== slug || parsedUrl.search !== "" || parsedUrl.hash !== "") {
                return false;
            }
        } catch (e) {
            return false;
        }

        if (entityType == "helpService") {
            return /^\/base-guide\/[a-z0-9]+(?:-[a-z0-9]+)*\/[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug);
        }

        if (entityType == "base") {
            return /^\/base-guide\/[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug);
        }

        return false;
    }

    private normalizePath(path: string): string {
        const normalizedPath = String(path || "").trim();
        return normalizedPath && normalizedPath.charAt(0) !== "/" ? "/" + normalizedPath : normalizedPath;
    }

    public getViewModelForRequest() {
        const vm = this.getTemplateViewModel();
        const slug = vm.isSlugReadOnly() ? vm.inferredSlug() : vm.slug();
        const request = {
            id: vm.id(),
            idBase: vm.idBase(),
            idCategory: vm.idCategory(),
            idParentBase: vm.idParentBase(),
            title: vm.title(),
            shortName: vm.shortName(),
            slug: this.normalizePath(slug),
            legacySlug: vm.legacySlug(),
            baseGroup: vm.baseGroup(),
            status: vm.status(),
            body: vm.body(),
            images: (vm.images() || []).map(image => this.getImageId(image)).filter(id => id),
            contacts: vm.linkedContactIds(),
            address: {
                street1: vm.addressStreet1(),
                street2: vm.addressStreet2(),
                zipCode: vm.addressZipCode(),
                buildingNumber: vm.addressBuildingNumber(),
                crossStreet: vm.addressCrossStreet(),
                city: vm.addressCity(),
                state: vm.addressState(),
                country: vm.addressCountry(),
            },
        };

        if (vm.entityType() == "base") {
            request["baseImage"] = this.getImageId(vm.baseImage());
        }

        return request;
    }

    protected getImageId(image): any {
        if (!image) {
            return null;
        }

        return typeof image == "object" ? image.id : image;
    }

    protected resolveImagePickerTarget(target): string {
        return target && target.editor ? target.editor : target;
    }

    protected isBodyImagePickerTarget(targetName: string): boolean {
        return targetName == "military_base_guide_body";
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/militaryBaseGuideEdit_template.ts